<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div style="padding:6px 15px; ">
			<Form ref="searchForm" :model="searchForm" label-position="left" :label-width="70" inline>
				<FormItem label="订单编号"><Input type="text" v-model="searchForm.orderid" placeholder="订单编号" /></FormItem>
				<FormItem label="订单类型">
					<Select v-model="searchForm.type" clearable>
						<Option value="all">通用</Option>
						<Option value="jcz">检测站</Option>
						<Option value="mj">免检</Option>
						<Option value="dj">代驾</Option>
					</Select>
				</FormItem>
				<FormItem label="使用状态">
					<Select v-model="searchForm.state" clearable>
						<Option value="0">未使用</Option>
						<Option value="1">已使用</Option>
					</Select>
				</FormItem>
				<FormItem label="所属会员"><Input type="text" v-model="searchForm.user" placeholder="手机号码" /></FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('searchForm')">
						<Icon type="ios-search" />
						搜索
					</Button>
				</FormItem>
			</Form>
		</div>
		<Table :data="tableData2" :columns="tableColumns2" size="large" border :loading="loading" header="header" footer="footer">
			<template slot-scope="{ row }" slot="type">
				<Tag color="primary" v-if="row.type == 'jcz'">检测站</Tag>
				<Tag color="success" v-else-if="row.type == 'mj'">免检</Tag>
				<Tag color="error" v-else-if="row.type == 'dj'">代驾</Tag>
				<Tag color="warning" v-else-if="row.type == 'all'">通用</Tag>
			</template>
			<template slot-scope="{ row }" slot="is_used">
				<span class="text-red" v-if="row.is_used == 0">未使用</span>
				<span class="text-green" v-else-if="row.is_used == 1">已使用</span>
				<span class="text-purple" v-else>未知</span>
			</template>
			<template slot-scope="{ row }" slot="money_str">
				<span class="text-red text-bold">{{ row.money_str }}</span>
			</template>
			<template slot-scope="{ row }" slot="date">
				<span class="text-red text-bold">{{ row.begin_date }} ~ {{ row.end_date }}</span>
			</template>

			<template slot="header">
				<div class="flex justify-between">
					<div span="12">
						<div class="padding-left">
							<Button type="success" @click="showCouponAddModal=true" icon="ios-add">添加优惠券</Button>
						</div>
					</div>
					<div span="12">
						<div style="text-align: right;">
							<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
							 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
						</div>
					</div>
				</div>

			</template>
			<template slot="footer">
				<div style="text-align: right;">
					<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
					 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
				</div>
			</template>
		</Table>
		<Modal v-model="showCouponAddModal" title="创建新订单" @on-ok="couponAddSubmit('formCouponAdd')" :mask-closable="false"
		 footer-hide>
			<div style="position: relative;" class="padding-left padding-right-xl">
				<Form ref="formCouponAdd" :model="formCouponAdd" label-position="right" :label-width="100" label-colon>
					<FormItem label="订单类型">
						<RadioGroup v-model="formCouponAdd.type">
							<Radio label="all">通用</Radio>
							<Radio label="jcz">检测站</Radio>
							<Radio label="dj">代驾</Radio>
							<Radio label="mj">免检</Radio>
						</RadioGroup>
					</FormItem>
					<FormItem label="名称">
						<Input v-model="formCouponAdd.name" maxlength="16"></Input>
					</FormItem>
					<FormItem label="金额">
						<Input v-model="formCouponAdd.money" maxlength="6" style="width:150px;"></Input>
					</FormItem>
					<FormItem label="数量">
						<InputNumber v-model="formCouponAdd.num" :editable="false"></InputNumber>
					</FormItem>
					<FormItem label="会员">
						<Select v-model="formCouponAdd.user" placeholder="输入会员手机号,可输入多个会员" filterable multiple allow-create clearable>
						</Select>
					</FormItem>
					<FormItem label="有效期">
						<DatePicker type="daterange" format="yyyy-MM-dd" @on-change="yxq_date" placeholder="选择有效日期" split-panels v-model="formCouponAdd.date"></DatePicker>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="couponAddSubmit('formCouponAdd')" :loading="couponAddLoading" icon="ios-add">提交</Button>
						<Button style="margin-left: 8px" @click="showCouponAddModal=false">取消</Button>
					</FormItem>
				</Form>
				<Spin fix v-if="couponAddLoading">
					<Icon type="ios-loading" size=28 class="demo-spin-icon-load"></Icon>
					<div>请稍候...</div>
				</Spin>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				jczList: [],
				state_arr: [],
				showCouponAddModal: false,
				formCouponAdd: {
					type: "jcz",
					name: "",
					date: "",
					user: "",
					num: 1,
					money: 0
				},
				loading: false,
				tableColumns2: [{
						title: 'id',
						type: 'index',
						width: 58
					},
					{
						title: '类型',
						align: 'center',
						slot: 'type'
					},
					{
						title: '金额',
						align: 'right',
						slot: 'money_str',
						width:120
					},
					{
						title: '有效期',
						slot: 'date',
						width:220
					},
					{
						title: '会员',
						key: 'user',
						align: 'center'
					},
					{
						title: '使用状态',
						slot: 'is_used',
						align: 'center',
						width: 135
					},
					{
						title: '订单号',
						key: 'orderid'
					},
					{
						title: '使用时间',
						key: 'usetime'
					},
					{
						title: '添加时间',
						key: 'addtime'
					}
				],
				tableData2: [],
				searchForm: {
					page: 1,
					size: 20,
					total: 0,
					orderid: '',
					type: '',
					is_used: '',
					user: ''
				},
				couponAddLoading: false
			};
		},
		methods: {
			handleSubmit(name) {
				this.loadinfos();
				return false;
			},
			loadinfos() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/order/coupon.php?a=list', this.$qs.stringify(this.searchForm)).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.searchForm.total = res.data.data.total;
							this.tableData2 = res.data.data.infos;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			pageChange(page) {
				this.searchForm.page = page;
				this.loadinfos();
			},
			pageSizeChange(size) {
				this.searchForm.size = size;
				this.loadinfos();
			},
			yxq_date(date) {
				this.formCouponAdd.date = date;
			},
			couponAddSubmit(name) {
				this.couponAddLoading = true;
				/*
				if (!this.formCouponAdd.name) {
					this.$Message.error({
						background: true,
						content: "请填写名称",
						onClose: () => {
							this.couponAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formCouponAdd.money) {
					this.$Message.error({
						background: true,
						content: "请填写联系人手机号",
						onClose: () => {
							this.couponAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formCouponAdd.linkman.address && this.formCouponAdd.type == "mj") {
					this.$Message.error({
						background: true,
						content: "请填写邮寄地址",
						onClose: () => {
							this.couponAddLoading = false;
						}
					});
					return false;
				}*/
				this.$http.post('/server/api/order/coupon.php?a=add', this.$qs.stringify(this.formCouponAdd)).then(
					res => {
						this.couponAddLoading = false;
						if (res.data.result == 'ok') {
							this.$Message.success({
								background: true,
								content: res.data.result.msg,
								onClose: () => {
									this.showCouponAddModal=false;
									this.searchForm.page=1;
									this.loadinfos();
								}
							});
						} else {
							
							this.$Modal.error({
								title: '创建订单失败',
								content: res.data.msg
							});
						}
					},
					r => {
						this.couponAddLoading = false;
						this.$Message.error('系统错误');
					}
				);
				return false;
			}
		},
		created() {
			this.loadinfos();
		}
	};
</script>

<style>
.demo-spin-icon-load{
	font-size:5em;
        animation: ani-demo-spin 1s linear infinite;
    }
</style>
